import { Component, Vue, Prop, Provide, Watch } from 'vue-property-decorator'
import { IProvider, IPoint, ITemedRequest, ILocation } from '../../models';
import { PersonItem } from '../PersonItem';
import { AppService } from '../../services/AppService';
import * as DataService from '../../services/DataService';
import * as DistanceUtils from '../../utils/DistanceUtils';
import * as GeoUtils from '../../utils/GeoUtils';
import { EventBus, TEMED_WIDGET_EVENTS } from '../../services/EventBus';

import './MostRatedWidget.scss';

@Component({
  template: require('./MostRatedWidget.html'),
  components:{
    'person-item': PersonItem
  }
})
export class MostRatedWidget extends Vue {
  @Prop({ default: 'Most Rated Doctors in' })
  title: string;

  @Prop({ default: '' })
  medcat: string;

  @Prop({ default: 'doctors' })
  type: string;

  @Prop({ default: 'Find more on temed.com' })
  linkText: string;

  @Prop({ default: 'https://www.temed.com/' })
  url: string;

  @Prop({ default: 4 })
  count: number;


  appService: AppService;

  items: IProvider[] = [];




  states = DataService.STATES;

  linkUrl = '';

  userLocation: ILocation = null;

  userState = DataService.DEFAULT_STATE;
  requestPosition = true;

  mapInited = false;

  mounted () {
    this.appService = AppService.getInstance();
    this.userLocation = this.appService.get('userLocation');
    this.userState = this.userLocation && this.userLocation.state ? this.userLocation.state : DataService.DEFAULT_STATE;

    GeoUtils.handlePermission((result) => this.handleGeoPermission(result));

    EventBus.$on(TEMED_WIDGET_EVENTS.GEO_LOCATION_CHANGED, () => {
      this.appService.getUserLocation()
        .then(location => {
          this.userLocation = location;
          this.userState = this.userLocation.state;
          this.initData();
        }).catch(e => {
          console.log(e);
        });
    });
    this.initData();
  }

  handleGeoPermission(result){
    // console.log(result);
    if(result.state !== 'prompt'){
      this.requestPosition = false;
    }else{
      this.requestPosition = true;
    }
  }

  @Watch('userState')
  onStateChange(event){
    if(this.userLocation){
      this.userLocation.state = this.userState;
      this.appService.set('userLocation', this.userLocation);
      EventBus.$emit(TEMED_WIDGET_EVENTS.GEO_LOCATION_CHANGED, this.userLocation);
    }else{
      this.initData();
    }
  }

  initData(){
    this.linkUrl = `${this.url}doctors?state=${this.userState}`;
    const request: ITemedRequest ={
      query: '*',
      query_type: this.type,
      page: 1,
      per_page: this.count,
      medcat_name: this.medcat,
      state: this.userState
    };
    DataService.searchProviders(request).then(response => {
      const providers = response.data.providers;
      if(this.userLocation != null && this.userLocation.latitude && this.userLocation.longitude){
        providers.map(item => {
          item.distance = DistanceUtils.calcProviderDistance(this.userLocation, item);
        });
      }
      this.items = providers.length > this.count ? providers.slice(0, this.count) : providers;
    }).catch(e => {
      console.error(e);
    });
  }

  shareLocation(event = null){
    if(event){
      event.preventDefault();
    }
    this.appService.requestLocation();
  }
}
